export default __webpack_public_path__ + "static/media/Aquarius.7c64ea51.svg";